import { Lang } from '../models';

/**
 * Converts the internal form model into the external NDTRC payload the API expects.
 *
 * Two shapes differ between the two models:
 *  - trcItemDetails is keyed by language internally, but a list of
 *    { lang, title, ... } entries externally;
 *  - single dates carry a client-side `id` that the API does not know.
 */
export const internalToExternal = (int: any): any => {
  if (!int) {
    throw new Error('No form data passed');
  }

  const ext = JSON.parse(JSON.stringify(int));

  if (int.trcItemDetails) {
    const languages: Lang[] = int.translations?.availableLanguages?.length
      ? int.translations.availableLanguages
      : Object.keys(int.trcItemDetails);

    ext.trcItemDetails = languages.map((lang: Lang) => {
      const detail = int.trcItemDetails[lang];
      if (!detail) {
        throw new Error(`Missing trcItemDetails for language "${lang}"`);
      }
      return { ...detail, lang };
    });
  }

  if (ext.calendar) {
    // `hasComment` is a client-side flag and has no counterpart in the NDTRC model.
    delete ext.calendar.hasComment;

    ext.calendar.singleDates = (ext.calendar.singleDates || []).map(
      (singleDate: any) => ({
        date: singleDate.date,
        when: (singleDate.when || [])
          .filter((when: any) => when && (when.timestart || when.timeend))
          .map((when: any) => ({
            // The API expects "13:00", not "13:00:00".
            timestart: when.timestart?.match(/[0-9]+:[0-9]+/)?.[0] || null,
            timeend: when.timeend?.match(/[0-9]+:[0-9]+/)?.[0] || null,
          })),
      })
    );
  }

  return ext;
};
